<template>
  <div>
    <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      服务领域
    </h3>
    <el-button type="primary" @click="dialogFormVisible=true;form={};fileList=[];" style="float:left;" plain>新增</el-button>
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%">
      <el-table-column
        prop="head"
        label="标题">
      </el-table-column>
      <el-table-column
        prop="headEn"
        label="英文">
      </el-table-column>
      <el-table-column
        prop="subhead"
        label="概要" width="200px">
      </el-table-column>
      <el-table-column
        prop="description"
        label="详情" width="500px">
        <template slot-scope="scope">
          <span v-html="scope.row.description"></span>
        </template>
      </el-table-column>
      <el-table-column
        label="图片路径">
        <template slot-scope="scope">
          <img :src="common.getPictureUrl(scope.row)" style="height: 100px;">
        </template>
      </el-table-column>
      <el-table-column
        prop="sequence"
        label="排序">
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否显示">
        <template slot-scope="scope">
          <span v-if="scope.row.status==='y'">显示</span>
          <span v-if="scope.row.status==='n'">不显示</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="contentHtml"
        label="详情">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="服务领域" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="服务标题" :label-width="formLabelWidth">
          <el-input v-model="form.head" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="服务英文" :label-width="formLabelWidth">
          <el-input v-model="form.headEn" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="服务内容" :label-width="formLabelWidth">
          <el-input v-model="form.subhead" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="配图" :label-width="formLabelWidth">
          <el-upload
            :action="this.$host+'upload'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="fileList"
            :on-success="uploadSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="form.image" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sequence" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <el-switch
            value="y"
            style="display: block"
            v-model="form.deleted"
            active-value="y"
            inactive-value="n"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="显示"
            inactive-text="不显示">
          </el-switch>
        </el-form-item>
        <el-form-item label="文章内容" :label-width="formLabelWidth">
          <vue-editor v-model="form.description"
                      useCustomImageHandler
                      @imageAdded="this.$common.handleImageAdded">
          </vue-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button @click="resetForm()">重置</el-button>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor'
    export default {
      name: "ServicesList",
      components: {
        VueEditor
      },
      methods: {
        submit(){
          const self = this
          this.form.type = 'service'
          let postData = self.$qs.stringify(this.form)
          let method = 'save'
          if(this.form.id){
            method = 'update'
          }
          self.$http.post(self.$host+'content/'+method,
            postData
          ).then(function (response) {
            self.$common.loginCheck(response.data.content)
            self.dialogFormVisible = false
            self.loadData()
          }).catch(e => {
            console.log(e)
          })
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        handleEdit(row){
          // 这里需要把row的数据拷贝一份，不然在编辑栏编辑的时候回改动列表的数据
          this.form = JSON.parse(JSON.stringify(row))
          this.dialogFormVisible = true;
        },
        handleDelete(row){
          this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const self = this
            row.type = 'service'
            let postData = self.$qs.stringify(row)
            self.$http.post(self.$host+'content/delete',
              postData
            ).then(function (response) {
              self.$common.loginCheck(response.data.content)
              self.tableData = response.data.list;
              self.dialogFormVisible = false
              self.loadData()
            }).catch(e => {
              console.log(e)
            })
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        },
        loadData(params) {
          const self = this
          let postData =
            self.$qs.stringify({
              'userId':'admin',
              'time': new Date().getTime(),
              'type': 'service',
            })
          self.$http.post(self.$host+'content/list',
            postData
          ).then(function (response) {
            console.log(response.data)
            self.tableData = response.data.content;
          }).catch(e => {
            console.log(e)
          })
        },
        uploadSuccess(response,file, fileList) {
          this.form.image = response.content;
        },
      },
      mounted() {
        this.$nextTick(() => {
          this.loadData();
        })
      },
      data() {
        return {
          tableData:[],
          dialogTableVisible: false,
          dialogFormVisible: false,
          form: {
            title: '',
          },
          formLabelWidth: '120px',
          dialogImageUrl: true,
          htmlContent:'',
          ruleForm:{

          },
          rules:{},
          dialogVisible: false,
          fileList:[],
          common:this.$common,
        };
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/ServicesManage.vue